module.exports = __webpack_public_path__ + "assets/img/8680f71368092e65a73c1dee55228668.svg";